webpackJsonp([1],{

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainPage__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MainPage__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'MainPage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_MainPage___default.a
  }]
}));

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(151),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function ConfigStorage(configKey) {
  this._configKey = configKey;
}

ConfigStorage.prototype.load = function () {
  var config = JSON.parse(localStorage.getItem(this._configKey) || '{ "pivotToken": "" }');
  return config;
};

ConfigStorage.prototype.save = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  localStorage.setItem(this._configKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config));
};

/* harmony default export */ __webpack_exports__["a"] = (ConfigStorage);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var Pivotal = void 0;

Pivotal = function Pivotal(apiToken) {
  this.apiToken = apiToken;
  this.baseUrl = 'https://www.pivotaltracker.com/services/v5/';
};

Pivotal.prototype.updateStory = function updateStory(projectId, storyId, params, callback) {
  this.api('put', 'projects/' + projectId + '/stories/' + storyId, {
    json: params
  }, callback);
};

Pivotal.prototype.getStory = function getStory(storyId, callback) {
  this.api('get', '/stories/' + storyId, {}, callback);
};

Pivotal.prototype.getProjects = function getProjects(callback) {
  this.api('get', '/projects', {}, callback);
};

Pivotal.prototype.getStories = function getStories(projectId, options, callback, completed, offset, limit) {
  this.paginated('projects/' + projectId + '/stories', offset || 0, limit || 128, options, callback, completed);
};

Pivotal.prototype.getActivity = function getActivity(projectId, options, callback, completed, offset, limit) {
  this.paginated('projects/' + projectId + '/activity', offset || 0, limit || 128, options, callback, completed);
};

Pivotal.prototype.getStoryActivity = function getStoryActivity(projectId, storyId, callback, options) {
  this.api('get', 'projects/' + projectId + '/stories/' + storyId + '/activity', {
    qs: options || {}
  }, callback);
};

Pivotal.prototype.getMyActivity = function getMyActivity(callback, options) {
  this.api('get', 'my/activity', {
    qs: options || {}
  }, callback);
};

Pivotal.prototype.getTasks = function getTasks(projectId, storyId, callback) {
  this.api('get', 'projects/' + projectId + '/stories/' + storyId + '/tasks', {}, callback);
};

Pivotal.prototype.addTask = function addTask(projectId, storyId, description, position, callback) {
  this.api('post', 'projects/' + projectId + '/stories/' + storyId + '/tasks', {
    body: {
      description: description,
      position: position
    }
  }, callback);
};

Pivotal.prototype.getIterations = function getIterations(projectId, options, callback, completed, offset, limit) {
  this.paginated('projects/' + projectId + '/iterations', offset || 0, limit || 128, options, callback, completed);
};

Pivotal.prototype.getCurrentIterations = function (projectId, callback) {
  this.api('get', 'projects/' + projectId + '/iterations', {
    qs: {
      scope: 'current',
      date_format: 'millis'
    }
  }, function (err, iterations) {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isFunction(callback)) {
      if (err || !iterations) {
        callback(err);
      } else {
        callback(false, iterations);
      }
    }
  });
};

Pivotal.prototype.getMemberships = function updateStory(projectId, callback) {
  this.api('get', 'projects/' + projectId + '/memberships', {}, callback);
};

Pivotal.prototype.getComments = function getStories(projectId, storyId, callback) {
  this.api('get', 'projects/' + projectId + '/stories/' + storyId + '/comments', {}, callback);
};

Pivotal.prototype.exportStories = function exportStories(stories, callback) {
  this.api('post', 'stories/export', {
    body: __WEBPACK_IMPORTED_MODULE_0_querystring___default.a.stringify({
      'ids[]': stories
    })
  }, callback);
};

Pivotal.prototype.getLabels = function getLabels(projectId, callback) {
  this.api('get', 'projects/' + projectId + '/labels', {}, callback);
};

Pivotal.prototype.getStoryLabels = function getStoryLabels(projectId, storyId, callback) {
  this.api('get', 'projects/' + projectId + '/stories/' + storyId + '/labels', {}, callback);
};

Pivotal.prototype.addStoryLabel = function addStoryLabel(projectId, storyId, name, callback) {
  this.api('post', 'projects/' + projectId + '/stories/' + storyId + '/labels', {
    body: {
      name: name
    }
  }, callback);
};

Pivotal.prototype.createLabel = function createStory(projectId, name, callback) {
  this.api('post', 'projects/' + projectId + '/labels', {
    body: {
      name: name
    }
  }, callback);
};

Pivotal.prototype.createStory = function createStory(projectId, params, callback) {
  this.api('post', 'projects/' + projectId + '/stories', {
    body: params
  }, callback);
};

Pivotal.prototype.paginated = function (path, offset, limit, options, callback, completed) {
  var that = this;
  var _options = {
    qs: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.extend({
      offset: offset,
      limit: limit,
      envelope: true
    }, options)
  };
  this.api('get', path, _options, function (err, res) {
    if (err || !res.pagination) {
      completed && completed(err || res);
    } else {
      offset += res.pagination.returned;
      callback && callback(res.data, res.pagination, function (err) {
        if (!err) {
          var left = res.pagination.total - offset;
          if (left > 0) {
            that.paginated(path, offset, Math.min(left, limit), options, callback, completed);
          } else {
            completed && completed();
          }
        } else {
          completed && completed(err);
        }
      });
    }
  });
};

Pivotal.prototype.api = function api(method, path, options, callback) {
  var xhr = new window.XMLHttpRequest();
  if (options.qs) {
    xhr.open(method, '' + this.baseUrl + path + '?' + __WEBPACK_IMPORTED_MODULE_0_querystring___default.a.stringify(options.qs));
  } else {
    xhr.open(method, '' + this.baseUrl + path);
  }
  xhr.responseType = 'json';
  xhr.setRequestHeader('X-TrackerToken', this.apiToken);

  xhr.onload = function () {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isFunction(callback)) {
      callback(undefined, xhr.response);
    }
  };

  xhr.onerror = function (err) {
    console.error("Houston, we've got a problem.", err, xhr);
    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isFunction(callback)) {
      callback(err);
    }
  };
  xhr.send();
};

/* harmony default export */ __webpack_exports__["a"] = (Pivotal);

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(128);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_pivotalJs__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_configStorage__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StoryCard__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StoryCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StoryCard__);








var CONFIG_STORAGE_KEY = 'pivot-board';
var configStorage = new __WEBPACK_IMPORTED_MODULE_1__lib_configStorage__["a" /* default */](CONFIG_STORAGE_KEY);

var buildIterationGraph = function buildIterationGraph(chart, iteration) {
  var dailyPoints = {
    labels: [],
    created: [],
    updated: [],
    accepted: [],
    todo: [],
    burn: []
  };

  var day = void 0;

  for (day = iteration.start; day <= iteration.finish; day += 86400000) {
    dailyPoints.labels.push(__WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('D MMM'));
    dailyPoints.created.push(iteration.stories.reduce(function (acc, story) {
      return story.created_at <= day ? acc + (story.estimate || 0) : acc;
    }, 0));
    dailyPoints.updated.push(iteration.stories.reduce(function (acc, story) {
      return story.updated_at <= day ? acc + (story.estimate || 0) : acc;
    }, 0));
    dailyPoints.accepted.push(iteration.stories.reduce(function (acc, story) {
      return story.accepted_at <= day ? acc + (story.estimate || 0) : acc;
    }, 0));
    dailyPoints.todo.push(dailyPoints.created[dailyPoints.created.length - 1] - dailyPoints.accepted[dailyPoints.accepted.length - 1]);
  }

  var days = -1;
  for (day = iteration.finish; day >= iteration.start; day -= 86400000) {
    var weekday = __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).weekday();
    if (weekday > 0 && weekday < 6) {
      days++;
    }
    dailyPoints.burn.unshift(days < 0 ? 0 : days);
  }

  var totalDaysDiv = 1 / dailyPoints.burn[0];
  for (day = 0; day < dailyPoints.burn.length; day++) {
    dailyPoints.burn[day] = dailyPoints.created[day] * dailyPoints.burn[day] * totalDaysDiv;
  }

  var data = {
    labels: dailyPoints.labels,
    series: [dailyPoints.created, dailyPoints.burn, dailyPoints.todo]
  };
  chart.update(data);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-page',
  components: { 'story-card': __WEBPACK_IMPORTED_MODULE_4__components_StoryCard___default.a },
  data: function data() {
    return {
      config: configStorage.load(),
      connected: false,
      pivotal: undefined,
      error: '',
      iterationCount: 1,
      mainChart: undefined,
      projects: undefined,
      stories: undefined,
      selectedProject: undefined
    };
  },

  watch: {
    iterationCount: function iterationCount() {
      this.selectProject(this.selectedProject);
    }
  },
  computed: {
    monitoring: function monitoring() {
      return this.config.connect;
    },
    todoStories: function todoStories() {
      return (this.stories || []).filter(function (story) {
        return ['planned', 'rejected'].includes(story.current_state);
      });
    },
    devStories: function devStories() {
      return (this.stories || []).filter(function (story) {
        return ['started', 'finished'].includes(story.current_state);
      });
    },
    qaStories: function qaStories() {
      return (this.stories || []).filter(function (story) {
        return ['delivered'].includes(story.current_state);
      });
    },
    doneStories: function doneStories() {
      return (this.stories || []).filter(function (story) {
        return ['accepted'].includes(story.current_state);
      });
    }
  },
  methods: {
    setToken: function setToken() {
      configStorage.save(this.config);
      this.connect();
    },
    disconnect: function disconnect() {
      this.connected = false;
      this.projects = undefined;
      this.stories = undefined;
      this.selectProject(undefined);
    },
    selectIteration: function selectIteration(iteration) {
      if (iteration) {
        this.stories = iteration.stories;

        buildIterationGraph(this.mainChart, iteration);
      } else {
        this.stories = undefined;
      }
    },
    selectProject: function selectProject(project) {
      var _this = this;

      this.selectedProject = project;
      this.selectIteration(undefined);
      if (project) {
        this.pivotal.getIterations(project.id, {
          scope: 'done_current',
          date_format: 'millis',
          offset: 1 - this.iterationCount
        }, function (iterations) {
          if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isError(iterations)) {
            console.error('selectedProject', iterations);
            return;
          }
          var summary = {
            start: iterations[0].start,
            finish: iterations[0].finish,
            stories: []
          };
          iterations.forEach(function (iteration) {
            summary.start = Math.min(summary.start, iteration.start);
            summary.finish = Math.max(summary.finish, iteration.finish);
            summary.stories = summary.stories.concat(iteration.stories);
          });
          _this.selectIteration(summary);
        });
      }
    },
    connect: function connect() {
      var _this2 = this;

      if (!this.config.pivotToken) {
        this.disconnect();
        return;
      }
      this.error = {};
      this.connected = true;
      this.pivotal = new __WEBPACK_IMPORTED_MODULE_0__lib_pivotalJs__["a" /* default */](this.config.pivotToken);
      this.pivotal.getProjects(function (err, projects) {
        if (err || projects.error) {
          _this2.error = err || projects;
          console.error(_this2.error);
          _this2.disconnect();
          return;
        }
        if (projects && projects.length > 0) {
          _this2.projects = projects;
          _this2.selectProject(projects[0]);
        }
      });
    }
  },
  updated: function updated() {
    var chartDom = document.querySelector('.ct-chart');
    if (chartDom && chartDom.__chartist__) {
      chartDom.__chartist__.update();
    }
  },
  mounted: function mounted() {
    this.connect();
    this.mainChart = new window.Chartist.Line('.ct-chart', {
      labels: ['new'],
      series: [[0, 30, 60, 90, 0, 100]]
    }, {
      axisY: {
        onlyInteger: true
      }
    });
  }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'story-card',
  props: ['story'],
  data: function data() {
    return {};
  },

  methods: {
    cardStyle: function cardStyle(story) {
      switch (story.current_state) {
        case 'planned':
          return 'card-outline-primary';
        case 'rejected':
          return 'card-outline-danger';
        case 'started':
          return 'card-outline-primary';
        case 'finished':
          return 'card-outline-warning';
        case 'delivered':
          return 'card-outline-primary';
        case 'accepted':
          return 'card-outline-success';
        default:
          return 'card-outline-secondary';
      }
    },
    cardGlyph: function cardGlyph(story) {
      switch (story.story_type) {
        case 'bug':
          return 'fas fa-bug';
        case 'chore':
          return 'fas fa-cog';
        case 'feature':
          return 'fas fa-star';
        case 'release':
          return 'fas fa-flag-checkered';
        default:
          return 'fas fa-question';
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 5,
	"./af.js": 5,
	"./ar": 12,
	"./ar-dz": 6,
	"./ar-dz.js": 6,
	"./ar-kw": 7,
	"./ar-kw.js": 7,
	"./ar-ly": 8,
	"./ar-ly.js": 8,
	"./ar-ma": 9,
	"./ar-ma.js": 9,
	"./ar-sa": 10,
	"./ar-sa.js": 10,
	"./ar-tn": 11,
	"./ar-tn.js": 11,
	"./ar.js": 12,
	"./az": 13,
	"./az.js": 13,
	"./be": 14,
	"./be.js": 14,
	"./bg": 15,
	"./bg.js": 15,
	"./bm": 16,
	"./bm.js": 16,
	"./bn": 17,
	"./bn.js": 17,
	"./bo": 18,
	"./bo.js": 18,
	"./br": 19,
	"./br.js": 19,
	"./bs": 20,
	"./bs.js": 20,
	"./ca": 21,
	"./ca.js": 21,
	"./cs": 22,
	"./cs.js": 22,
	"./cv": 23,
	"./cv.js": 23,
	"./cy": 24,
	"./cy.js": 24,
	"./da": 25,
	"./da.js": 25,
	"./de": 28,
	"./de-at": 26,
	"./de-at.js": 26,
	"./de-ch": 27,
	"./de-ch.js": 27,
	"./de.js": 28,
	"./dv": 29,
	"./dv.js": 29,
	"./el": 30,
	"./el.js": 30,
	"./en-au": 31,
	"./en-au.js": 31,
	"./en-ca": 32,
	"./en-ca.js": 32,
	"./en-gb": 33,
	"./en-gb.js": 33,
	"./en-ie": 34,
	"./en-ie.js": 34,
	"./en-il": 35,
	"./en-il.js": 35,
	"./en-nz": 36,
	"./en-nz.js": 36,
	"./eo": 37,
	"./eo.js": 37,
	"./es": 40,
	"./es-do": 38,
	"./es-do.js": 38,
	"./es-us": 39,
	"./es-us.js": 39,
	"./es.js": 40,
	"./et": 41,
	"./et.js": 41,
	"./eu": 42,
	"./eu.js": 42,
	"./fa": 43,
	"./fa.js": 43,
	"./fi": 44,
	"./fi.js": 44,
	"./fo": 45,
	"./fo.js": 45,
	"./fr": 48,
	"./fr-ca": 46,
	"./fr-ca.js": 46,
	"./fr-ch": 47,
	"./fr-ch.js": 47,
	"./fr.js": 48,
	"./fy": 49,
	"./fy.js": 49,
	"./gd": 50,
	"./gd.js": 50,
	"./gl": 51,
	"./gl.js": 51,
	"./gom-latn": 52,
	"./gom-latn.js": 52,
	"./gu": 53,
	"./gu.js": 53,
	"./he": 54,
	"./he.js": 54,
	"./hi": 55,
	"./hi.js": 55,
	"./hr": 56,
	"./hr.js": 56,
	"./hu": 57,
	"./hu.js": 57,
	"./hy-am": 58,
	"./hy-am.js": 58,
	"./id": 59,
	"./id.js": 59,
	"./is": 60,
	"./is.js": 60,
	"./it": 61,
	"./it.js": 61,
	"./ja": 62,
	"./ja.js": 62,
	"./jv": 63,
	"./jv.js": 63,
	"./ka": 64,
	"./ka.js": 64,
	"./kk": 65,
	"./kk.js": 65,
	"./km": 66,
	"./km.js": 66,
	"./kn": 67,
	"./kn.js": 67,
	"./ko": 68,
	"./ko.js": 68,
	"./ky": 69,
	"./ky.js": 69,
	"./lb": 70,
	"./lb.js": 70,
	"./lo": 71,
	"./lo.js": 71,
	"./lt": 72,
	"./lt.js": 72,
	"./lv": 73,
	"./lv.js": 73,
	"./me": 74,
	"./me.js": 74,
	"./mi": 75,
	"./mi.js": 75,
	"./mk": 76,
	"./mk.js": 76,
	"./ml": 77,
	"./ml.js": 77,
	"./mr": 78,
	"./mr.js": 78,
	"./ms": 80,
	"./ms-my": 79,
	"./ms-my.js": 79,
	"./ms.js": 80,
	"./mt": 81,
	"./mt.js": 81,
	"./my": 82,
	"./my.js": 82,
	"./nb": 83,
	"./nb.js": 83,
	"./ne": 84,
	"./ne.js": 84,
	"./nl": 86,
	"./nl-be": 85,
	"./nl-be.js": 85,
	"./nl.js": 86,
	"./nn": 87,
	"./nn.js": 87,
	"./pa-in": 88,
	"./pa-in.js": 88,
	"./pl": 89,
	"./pl.js": 89,
	"./pt": 91,
	"./pt-br": 90,
	"./pt-br.js": 90,
	"./pt.js": 91,
	"./ro": 92,
	"./ro.js": 92,
	"./ru": 93,
	"./ru.js": 93,
	"./sd": 94,
	"./sd.js": 94,
	"./se": 95,
	"./se.js": 95,
	"./si": 96,
	"./si.js": 96,
	"./sk": 97,
	"./sk.js": 97,
	"./sl": 98,
	"./sl.js": 98,
	"./sq": 99,
	"./sq.js": 99,
	"./sr": 101,
	"./sr-cyrl": 100,
	"./sr-cyrl.js": 100,
	"./sr.js": 101,
	"./ss": 102,
	"./ss.js": 102,
	"./sv": 103,
	"./sv.js": 103,
	"./sw": 104,
	"./sw.js": 104,
	"./ta": 105,
	"./ta.js": 105,
	"./te": 106,
	"./te.js": 106,
	"./tet": 107,
	"./tet.js": 107,
	"./tg": 108,
	"./tg.js": 108,
	"./th": 109,
	"./th.js": 109,
	"./tl-ph": 110,
	"./tl-ph.js": 110,
	"./tlh": 111,
	"./tlh.js": 111,
	"./tr": 112,
	"./tr.js": 112,
	"./tzl": 113,
	"./tzl.js": 113,
	"./tzm": 115,
	"./tzm-latn": 114,
	"./tzm-latn.js": 114,
	"./tzm.js": 115,
	"./ug-cn": 116,
	"./ug-cn.js": 116,
	"./uk": 117,
	"./uk.js": 117,
	"./ur": 118,
	"./ur.js": 118,
	"./uz": 120,
	"./uz-latn": 119,
	"./uz-latn.js": 119,
	"./uz.js": 120,
	"./vi": 121,
	"./vi.js": 121,
	"./x-pseudo": 122,
	"./x-pseudo.js": 122,
	"./yo": 123,
	"./yo.js": 123,
	"./zh-cn": 124,
	"./zh-cn.js": 124,
	"./zh-hk": 125,
	"./zh-hk.js": 125,
	"./zh-tw": 126,
	"./zh-tw.js": 126
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 142;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(152),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68776ea4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(153),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e723abce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 151:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v("Loading...")]), _vm._v(" "), _c('section', {
    staticClass: "serverapp"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-sm navbar-light bg-light"
  }, [_c('a', {
    staticClass: "navbar-brand"
  }, [_vm._v("Pivotal Board")]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projects),
      expression: "projects"
    }],
    staticClass: "form-inline"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projects),
      expression: "projects"
    }],
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iterationCount),
      expression: "iterationCount"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9"
    },
    domProps: {
      "value": (_vm.iterationCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.iterationCount = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projects),
      expression: "projects"
    }],
    staticClass: "nav nav-pills"
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('li', {
      key: project.id,
      staticClass: "nav-item"
    }, [_c('a', {
      staticClass: "nav-link",
      class: {
        active: project == _vm.selectedProject
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.selectProject(project)
        }
      }
    }, [_vm._v(_vm._s(project.name))])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.connected),
      expression: "!connected"
    }],
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.pivotToken),
      expression: "config.pivotToken"
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": "",
      "autocomplete": "off",
      "placeholder": "Enter token here"
    },
    domProps: {
      "value": (_vm.config.pivotToken)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.setToken()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "pivotToken", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto justify-content-end"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.connected),
      expression: "!connected"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setToken()
      }
    }
  }, [_vm._v("\n              Connect\n          ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.connected),
      expression: "connected"
    }],
    staticClass: "btn btn-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.disconnect()
      }
    }
  }, [_vm._v("\n              Disconnect\n          ")])])])]), _vm._v(" "), _c('main', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.connected),
      expression: "!connected"
    }],
    staticClass: "row"
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.possible_fix),
      expression: "error.possible_fix"
    }],
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.error.error))]), _vm._v(" " + _vm._s(_vm.error.possible_fix) + "\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.message),
      expression: "error.message"
    }],
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.error.name))]), _vm._v(" " + _vm._s(_vm.error.message) + "\n      ")]), _vm._v(" "), _c('div', [_c('h1', [_vm._v("Stories")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stories),
      expression: "stories"
    }],
    staticClass: "scrum-board"
  }, [_c('div', {
    staticClass: "scrum-group"
  }, [_c('h2', [_vm._v("Todo")]), _vm._v(" "), _vm._l((_vm.todoStories), function(story, index) {
    return _c('story-card', {
      key: story.id,
      attrs: {
        "story": story
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "scrum-group"
  }, [_c('h2', [_vm._v("Dev")]), _vm._v(" "), _vm._l((_vm.devStories), function(story, index) {
    return _c('story-card', {
      key: story.id,
      attrs: {
        "story": story
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "scrum-group"
  }, [_c('h2', [_vm._v("QA")]), _vm._v(" "), _vm._l((_vm.qaStories), function(story, index) {
    return _c('story-card', {
      key: story.id,
      attrs: {
        "story": story
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "scrum-group"
  }, [_c('h2', [_vm._v("Done")]), _vm._v(" "), _vm._l((_vm.doneStories), function(story, index) {
    return _c('story-card', {
      key: story.id,
      attrs: {
        "story": story
      }
    })
  })], 2)])]), _vm._v(" "), _vm._m(4)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Show")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Iterations")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Pivotal API Token")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    attrs: {
      "href": "https://www.pivotaltracker.com/profile"
    }
  }, [_vm._v("Get your API Token from your PivotalTracker Profile page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "ct-chart ct-square"
  })])
}]}

/***/ }),

/***/ 153:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('a', {
    staticClass: "left",
    attrs: {
      "href": _vm.story.url
    }
  }, [_vm._v(_vm._s(_vm.story.id))]), _vm._v(" "), _c('span', {
    class: _vm.cardGlyph(_vm.story)
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.story.estimate),
      expression: "story.estimate"
    }],
    staticClass: "right badge badge-primary"
  }, [_vm._v(_vm._s(_vm.story.estimate))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.story.estimate),
      expression: "!story.estimate"
    }],
    staticClass: "right badge badge-primary"
  }, [_vm._v("-")])]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.story.name))]), _vm._v(" "), _c('div')])])
},staticRenderFns: []}

/***/ })

},[132]);


// WEBPACK FOOTER //
// static/js/app.dcbb0805e3380a5120eb.js